<template>

    <div id="processors">

        <div class="flex">
            <div class="flex-1 mb-4">
                <h1 class="text-2xl font-medium text-gray-900 capitalize">Processors</h1>
            </div>

            <div class="flex mb-4 justify-end">
                <router-link :to="{ name: 'processors.create' }" custom v-slot="{ navigate }">
                    <button @click="navigate" class="btn">
                        Create Processor
                    </button>
                </router-link>
            </div>
        </div>

        <div class="flex flex-col"  v-if="loaded">

            <div class="index-table" v-if="form.indexDataAvailable()">
                <div>
                    <div>
                        <table>
                            <thead>
                            <tr>
                                <th scope="col" class="text-left tracking-wider">&nbsp;</th>
                                <th scope="col" class="text-left tracking-wider">
                                    Processor ID
                                </th>
                                <th scope="col" class="hidden lg:table-cell text-center tracking-wider">
                                    Driver
                                </th>
                                <th scope="col" class="hidden lg:table-cell text-right tracking-wider">
                                    Created
                                </th>
                                <th scope="col" class="relative p-3">
                                    <span class="sr-only">Edit Processor</span>
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr class="colored-row" v-for="(processor, index) in form.index_data.data" @click.prevent="">
                                <td>&nbsp;</td>
                                <td>
                                    <span class="font-medium text-gray-700">{{ processor.id }}</span>
                                    <span v-if="processor.tenant_name">({{processor.tenant_name}})</span>
                                    <br>
                                    <span class="text-xs text-gray-400">{{ processor.endpoint }}</span>
                                </td>
                                <td class="hidden lg:table-cell text-center">
                                    <span class="status-box status-complete">{{ processor.driver }}</span>
                                </td>
                                <td class="hidden lg:table-cell text-right">
                                    {{ formatDate(processor.created_at) }}<br>
                                    <span class="text-xs text-gray-400">Last used <span class="">Last Updated {{ formatDate(processor.updated_at) }}</span></span>
                                </td>
                                <td class="text-right">
                                    <router-link :to="{ name: 'processors.edit', params: { processor: processor.id } }" custom v-slot="{ navigate }">
                                        <button @click="navigate" class="btn-outline text-sm">
                                            Edit Processor
                                        </button>
                                    </router-link>
                                </td>
                            </tr>
                            <tr class="py-6 text-xs font-medium">
                                <td colspan="7" class="text-center">
                                    <infinite-loading @infinite="infiniteHandler">
                                        <div slot="spinner">Loading...</div>
                                        <div slot="no-more">No more processors</div>
                                    </infinite-loading>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

            </div>
            <div class="panel" v-else>
                <div class="p-10">
                    <div class="text-gray-200 my-6">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-20 w-20 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 3v2m6-2v2M9 19v2m6-2v2M5 9H3m2 6H3m18-6h-2m2 6h-2M7 19h10a2 2 0 002-2V7a2 2 0 00-2-2H7a2 2 0 00-2 2v10a2 2 0 002 2zM9 9h6v6H9V9z" />
                        </svg>
                    </div>

                    <h2 class="text-gray-600 font-medium text-2xl text-center">No Processors Available</h2>

                    <p class="text-center mt-4 text-sm text-gray-500">
                        We could not find any processors.
                    </p>
                </div>
            </div>

        </div>
        <Loading message="Loading Processors" v-else></Loading>

    </div>

</template>

<script>
import Loading from "../Support/Loading";
import InfiniteLoading from "vue-infinite-loading";
import {Processor} from "../../app/Procesor/Processor";
import {FormattingMixin, PermissionMixin} from "../../support/mixins";

export default {
    name: "Processors",
    mixins: [PermissionMixin, FormattingMixin],
    data() {
        return {
            form: null,
            loaded: false,
        }
    },
    components: {
        Loading,
        InfiniteLoading
    },
    methods: {        
        infiniteHandler($state) {
            let vm = this;

            vm.form.page += 1;

            if (vm.form.indexHasMoreResults()) {
                this.form.index(true).then(response => {
                    $state.loaded();
                });
            } else {
                $state.loaded();
                $state.complete();
            }
        }
    },
    mounted() {
        let vm = this;

        new Promise(resolve => {
            vm.form = new Processor();

            vm.form.index().then(response => {
                resolve(true);
            }).catch(error => vm.handleError(error));

        }).then(result => {
            vm.loaded = result;
        });
    }
}
</script>


